export const iconFontAwesomeAutomotiveBus = (
	<i className="fa-solid fa-bus"></i>
);
